import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { PageHeader,Tag, Button } from 'antd';

import { pageHeaderStyle, pageTitle } from '../util/Style';

import { AgGridReact } from 'ag-grid-react';

import ProductListStore from '../stores/ProductListStore';

const height = window.innerHeight * .80;

const defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    flex: 1,
    width:100,
};

const columnDefs = [
    { headerName: 'Id', field: 'ProfileID', pinned: 'left', type: 'numberColumn'},
    {
        headerName: 'Status',
        field: 'price_update_flag',
        width: 10,
        pinned:'left',
        type: 'numberColumn',
        cellStyle: params => {
            if (params.value === 2) {
                return {color: 'white', backgroundColor: 'rgb(27,160,97)'};
            }
            if (params.value === 1) {
                return {color: 'black', backgroundColor: 'rgb(255,230,114)'};
            }
            return {color: 'white', backgroundColor: 'rgb(204,47,16)'};
        }
    },
    { headerName: 'Code', field: 'ProfileCode', pinned: 'left',width: 100 },
    { headerName: 'Name', field: 'ProfileName', filter: 'agTextColumnFilter', pinned: 'left',width: 300},
    { headerName: 'Lab Price', field: 'labPrice',width: 50 },
    { headerName: 'Self Price', field: 'selfPrice',width: 50 },
    { headerName: 'Instructions', field: 'Special_instructions',width: 150 },
];

class ProfileListUI extends Component {

    gridRef = React.createRef();

    constructor(props) {
        super(props);
        this.store = new ProductListStore({ apiProxy: props.appStore.apiProxy })
    }

    fetchProfileData = () => {
        this.store.fetchProfiles();
    }

    countTag = () => {
        if (this.store.isDone) {
            return <Tag color="#108ee9">{this.store.rowCount} Total</Tag>
        }

        if (this.store.isError) {
            return <Tag color="red">...</Tag>
        }
    }

    exportCsv = () => {
        return(
            <Button onClick={() => this.onBtExport()} shape="round" style={{ background: "rgb(27,160,97)", color: "white" }} >Export CSV</Button>
        )
    }

    onBtExport = async () => {
        await this.gridRef.current.api.exportDataAsCsv();
    };

    onSelectionChanged = () => {
        const selectedRows = this.gridRef.current.api.getSelectedRows();
        
        const productId = selectedRows[0].ProfileID;
        const productName = selectedRows[0].ProfileName;
        const departmentId = selectedRows[0].DepartmentId;
        const labPrice = selectedRows[0].labPrice;
        const selfPrice = selectedRows[0].selfPrice;
        const priceUpdateFlag = selectedRows[0].price_update_flag

        const params = {parentKey: "profiles", kind:"profile", productId, productName, departmentId,labPrice,selfPrice,priceUpdateFlag};

        this.props.appStore.currentComponent = { label: "Profile Price", key: "priceList", params: params };  
    }

    render() {
        const products = this.store.products;
        return (
            <>
                <PageHeader 
                    style={pageHeaderStyle} 
                    title={pageTitle("Profiles")}
                    tags={this.countTag()}
                    extra={this.exportCsv()}
                >
                </PageHeader>
                <div className="ag-theme-alpine" style={{ height: height, width: '100%' }}>
                    <AgGridReact
                        rowHeight={30}
                        ref={this.gridRef}
                        defaultColDef={defaultColDef}
                        rowData={products}
                        rowSelection={'single'}
                        onSelectionChanged={this.onSelectionChanged}
                        columnDefs={columnDefs}
                        onGridReady={this.fetchProfileData}>
                    </AgGridReact>
                </div>
            </>
        )
    }
}

export default observer(ProfileListUI)
